module.exports = __webpack_public_path__ + "img/KN.0181bd62.png";